import React, { useEffect, useState, useRef } from 'react';

import { Column, InlineLoading } from '@carbon/react';
import {
  Panel,
  PanelFooter,
  PanelHeader,
  PanelLabel,
  PanelProgress,
} from '../Panel/Panel';
import { useLazyGetLicenceStatisticQuery } from '@/redux/new_services/organisation';
import useUser from '@/lib/hooks/useUser';

export const Licences = ({ small = false }) => {

  const { organisationID } = useUser();

  useEffect(() => {
    if (organisationID && organisationID > 0) {
      trigger(organisationID);
    }
  }, [organisationID, trigger]);

  const [trigger, {
    data: userData,
    isFetching,
  }] = useLazyGetLicenceStatisticQuery({refetchOnMountOrArgChange: false});


  return (
    <Panel halfSize={small}>
      <PanelHeader
        header
        helpText="Zeigt dir die verwendeten und Verfügbaren Lizenzen an">
        Lizenzen
      </PanelHeader>
      <PanelLabel centered bold>
        {isFetching && <InlineLoading status="active"/>}
        {!isFetching && (
          <>
            {userData?.in_use} von {userData?.total}
          </>
        )}
      </PanelLabel>
      <PanelLabel centered semi>
        Lizenzen sind in Verwendung
      </PanelLabel>

      {isFetching && <InlineLoading status="active"/>}
      {!isFetching && <PanelProgress max={userData?.total} current={userData?.in_use}></PanelProgress>}
      <PanelFooter></PanelFooter>
    </Panel>
  );
};
